import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
// ---- external imports -----

import { financialStatementsSelectors } from '~/store';
// ---- internal imports ----

import * as actionTypes from '../actionTypes';
import { updateErrorConfigurationAfterUserUpdate } from '../actions';
// ---- parent imports ----

const STATEMENT_CORRESPONDING_ACTION = {
    [actionTypes.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER]: 'incomeStatement',
    [actionTypes.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER]: 'balanceSheet',
};

const errorHandlingEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            actionTypes.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER,
            actionTypes.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER,
        ),
        map(action => {
            const isCorrectingErrorsAfterSubmissionAttempt =
                financialStatementsSelectors.isCorrectingErrorsAfterSubmissionAttempt(state$.value);
            const statementType = STATEMENT_CORRESPONDING_ACTION[action.type];

            if (isCorrectingErrorsAfterSubmissionAttempt) {
                let statement = null;

                switch (statementType) {
                    case 'incomeStatement':
                        statement = action.updatedIncomeStatement;
                        break;
                    case 'balanceSheet':
                        statement = action.updatedBalanceSheet;
                        break;
                    default:
                        console.error('invalid statement type passed to error handler');
                }
                return updateErrorConfigurationAfterUserUpdate(action.quarterNum, statementType, statement);
            }
        }),
        filter(Boolean),
    );

export default errorHandlingEpic;
